import { StatefulPanelProps as _StatefulPanelProps } from 'baseui/accordion';
import React from 'react';
import { ISmartProps } from './types';
import { StatefulViewPanel, ViewPanel } from './viewPanel';

export { PanelFooter } from './viewPanel';

export type PanelProps = ISmartProps;
export type StatefulPanelProps = ISmartProps & _StatefulPanelProps;

export const StatefulPanel = (props: ISmartProps & StatefulPanelProps) => {
	return <StatefulViewPanel {...props} />;
};

export const Panel = React.forwardRef((props: ISmartProps, ref: any) => {
	return <ViewPanel ref={ref} {...props} />;
});
